// extracted by mini-css-extract-plugin
module.exports = {"StoriesGrid":"styles_StoriesGrid__wvPSh","cardsGrid":"styles_cardsGrid__ZCFDn","tetris":"styles_tetris__Ci4ct","triangle":"styles_triangle__h2C97"};